import type { SVGProps } from 'react';

type IconProps = SVGProps<SVGSVGElement> & { size?: number };

function baseProps({ size = 20, ...props }: IconProps) {
  return {
    width: size,
    height: size,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 2,
    strokeLinecap: 'round' as const,
    strokeLinejoin: 'round' as const,
    ...props,
  };
}

export function SearchIcon(props: IconProps) {
  return <svg {...baseProps(props)}><circle cx="11" cy="11" r="7.5" /><path d="m20 20-3.5-3.5" /></svg>;
}

export function ArrowLeftIcon(props: IconProps) {
  return <svg {...baseProps(props)}><path d="m15 18-6-6 6-6" /></svg>;
}

export function ArrowRightIcon(props: IconProps) {
  return <svg {...baseProps(props)}><path d="m9 6 6 6-6 6" /></svg>;
}

export function PlusIcon(props: IconProps) {
  return <svg {...baseProps(props)}><path d="M12 5v14" /><path d="M5 12h14" /></svg>;
}

export function MinusIcon(props: IconProps) {
  return <svg {...baseProps(props)}><path d="M5 12h14" /></svg>;
}

export function CloseIcon(props: IconProps) {
  return <svg {...baseProps(props)}><path d="m18 6-12 12" /><path d="m6 6 12 12" /></svg>;
}

export function ShoppingCartIcon(props: IconProps) {
  return <svg {...baseProps(props)}><circle cx="9" cy="20" r="1.5" /><circle cx="18" cy="20" r="1.5" /><path d="M3 4h2l2.2 10.2a2 2 0 0 0 2 1.6h7.7a2 2 0 0 0 2-1.6L21 7H6" /></svg>;
}

export function UserIcon(props: IconProps) {
  return <svg {...baseProps(props)}><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" /></svg>;
}

export function LoginIcon(props: IconProps) {
  return <svg {...baseProps(props)}><path d="M10 17 15 12l-5-5" /><path d="M15 12H3" /><path d="M21 3v18" /></svg>;
}

export function LogoutIcon(props: IconProps) {
  return <svg {...baseProps(props)}><path d="M14 17l5-5-5-5" /><path d="M19 12H7" /><path d="M7 21H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h3" /></svg>;
}

export function GridIcon(props: IconProps) {
  return <svg {...baseProps(props)}><rect x="3" y="3" width="7" height="7" rx="1.5" /><rect x="14" y="3" width="7" height="7" rx="1.5" /><rect x="3" y="14" width="7" height="7" rx="1.5" /><rect x="14" y="14" width="7" height="7" rx="1.5" /></svg>;
}

export function FlashIcon(props: IconProps) {
  return <svg {...baseProps(props)}><path d="M13 2 4 14h6l-1 8 9-12h-6z" /></svg>;
}

export function PackageIcon(props: IconProps) {
  return <svg {...baseProps(props)}><path d="m21 8-9 5-9-5 9-5 9 5Z" /><path d="m3 8 9 5 9-5" /><path d="M12 13v9" /></svg>;
}

export function ShieldIcon(props: IconProps) {
  return <svg {...baseProps(props)}><path d="M12 3 4.5 6.5V12c0 5.2 3.4 8.9 7.5 9.5 4.1-.6 7.5-4.3 7.5-9.5V6.5L12 3Z" /><path d="m9.5 12 1.8 1.8 3.8-4" /></svg>;
}

export function ImageIcon(props: IconProps) {
  return <svg {...baseProps(props)}><rect x="3" y="5" width="18" height="14" rx="2" /><circle cx="9" cy="10" r="1.5" /><path d="m21 16-4.5-4.5a2 2 0 0 0-2.8 0L7 18" /></svg>;
}

export function EyeIcon(props: IconProps) {
  return <svg {...baseProps(props)}><path d="M2.5 12s3.5-6.5 9.5-6.5S21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12Z" /><circle cx="12" cy="12" r="3" /></svg>;
}

export function EyeOffIcon(props: IconProps) {
  return <svg {...baseProps(props)}><path d="M3 3l18 18" /><path d="M10.6 10.6a3 3 0 1 0 4.2 4.2" /><path d="M6.5 6.9C3.9 8.7 2.5 12 2.5 12s3.5 6.5 9.5 6.5c1.2 0 2.3-.2 3.3-.5" /><path d="M9.5 4.6c.8-.2 1.6-.3 2.5-.3 6 0 9.5 6.5 9.5 6.5s-.8 1.4-2.2 3.1" /></svg>;
}

export function WrenchIcon(props: IconProps) {
  return <svg {...baseProps(props)}><path d="M14.7 6.3a4 4 0 0 0-5.4 5.4L4 17v3h3l5.3-5.3a4 4 0 0 0 5.4-5.4l-2.3 2.3-2-2 2.3-2.3Z" /></svg>;
}

export function ChipIcon(props: IconProps) {
  return <svg {...baseProps(props)}><rect x="7" y="7" width="10" height="10" rx="2" /><path d="M9 1v3" /><path d="M15 1v3" /><path d="M9 20v3" /><path d="M15 20v3" /><path d="M20 9h3" /><path d="M20 14h3" /><path d="M1 9h3" /><path d="M1 14h3" /></svg>;
}
